import { render, staticRenderFns } from "./ResourceSearch.vue?vue&type=template&id=e30ed754&scoped=true"
import script from "./ResourceSearch.vue?vue&type=script&lang=js"
export * from "./ResourceSearch.vue?vue&type=script&lang=js"
import style0 from "./ResourceSearch.vue?vue&type=style&index=0&id=e30ed754&prod&scoped=true&lang=scss"
import style1 from "./ResourceSearch.vue?vue&type=style&index=1&id=e30ed754&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e30ed754",
  null
  
)

export default component.exports